import React from 'react';
import './ImageStyleSheet.css';

function OneChestNut() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/one_chest_nut.jpg" className='img-view'/>
        </div>
        
    )
}

export default OneChestNut
